export default __webpack_public_path__ + "static/media/paymentCard.1ac3f535.jpg";